class ConfigService {
  $http: ng.IHttpService;
  cachedConfigPromise: any;
  constructor($http) {
    this.$http = $http;
    this.cachedConfigPromise = null;
  }

  config() {
    if (!this.cachedConfigPromise) {
      this.cachedConfigPromise = this.$http.get('/api/v1/config').then(null, (error) => {
        // do not cache a failed request: the next call retries
        this.cachedConfigPromise = null;
        throw error;
      });
    }

    return this.cachedConfigPromise;
  }
}

ConfigService.$inject = ['$http'];

export default ConfigService;
